/**
 * There are some workarounds here to ensure that the code is compatible with pollinator bundler.
 * We are not using the facade here as it includes dependencies into the routes file that cause issues & we define the custom type here to avoid the issues.
 */
type Window =
	| {
			location: {
				hostname: string;
			};
	  }
	| undefined;
declare const window: Window;

const STANDALONE_TEAMS_APP_HOSTNAMES = [
	'teams-app.stg-east.frontend.public.atl-paas.net',
	'teams.stg.atlassian.com',
	'teams.atlassian.com',
];
export const isStandaloneTeamsApp = () => {
	if (typeof window === 'undefined') {
		return false;
	}

	return STANDALONE_TEAMS_APP_HOSTNAMES.includes(window.location.hostname);
};
